import React from 'react';
import SubServices from '../common/sub-services';
const NodejsSolution = () => {
    return (
        <div className="section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="pb-[10px]">
                            Industry-Specific Node.js Solutions
                        </h2>
                        <p data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            At Moweb, we understand that every industry has unique requirements. Our Node.js development services
                            are designed to meet the specific needs of various sectors, including healthcare, finance, eCommerce,
                            and education. Whether you need a secure healthcare platform, an advanced financial system, or a
                            dynamic eCommerce site, our team can tailor Node.js solutions to your industry.
                        </p>
                    </div>
                </div>

                <div className="row grid lg:grid-cols-12 xl:grid-cols-12 mb-10">
                    <div className="xl:col-span-4 lg:col-span-6 md:col-span-6 xl:col-start-3 lg:col-start-1 md:col-start-1">
                        <SubServices
                            path={'/img/icons/ic-healthcare.svg'}
                            height={64}
                            width={64}
                            alt="Healthcare"
                            title="Healthcare"
                            serviceName="Healthcare"
                            serviceDescription="Build HIPAA-compliant, secure healthcare apps that offer real-time data processing and integration with various healthcare systems."
                        />
                    </div>
                    <div className="xl:col-span-4 lg:col-span-6 md:col-span-6">
                        <SubServices
                            path={'/img/icons/ic-finance.svg'}
                            height={64}
                            width={64}
                            alt="Finance"
                            title="Finance"
                            serviceName="Finance"
                            serviceDescription="Develop scalable financial applications with enhanced security and real-time transaction handling."
                        />
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 xl:grid-cols-12">
                    <div className="xl:col-span-4 lg:col-span-6 md:col-span-6 xl:col-start-3 lg:col-start-1 md:col-start-1">
                        <SubServices
                            path={'img/icons/ic-ecommerce.svg'}
                            height={64}
                            width={64}
                            alt="eCommerce"
                            title="eCommerce"
                            serviceName="eCommerce"
                            serviceDescription="Utilize Node.js to create robust, scalable eCommerce platforms that support high user loads and offer seamless user experiences."
                        />
                    </div>
                    <div className="xl:col-span-4 lg:col-span-6 md:col-span-6">
                        <SubServices
                            path={'/img/icons/ic-education.svg'}
                            height={64}
                            width={64}
                            alt="Education"
                            title="Education"
                            serviceName="Education"
                            serviceDescription="Create interactive learning platforms that provide real-time collaboration tools and seamless content delivery."
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NodejsSolution;
